import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import * as styles from './Snackbar.css';

const cx = classnames.bind(styles);

export function SnackbarAction({ testId, className, children, ...props }) {
    const classes = cx('action', className);

    return (
        <div data-testid={testId} className={classes} {...props}>
            {children}
        </div>
    );
}

SnackbarAction.propTypes = {
    /**
     * Emit a `data-testid` prop on the root element of the component. Use this
     * to help automated testing tools find this particular component.
     */
    testId: PropTypes.string,

    /**
     * Set additional CSS classes on the component to extend the default styles.
     */
    className: PropTypes.string,

    /**
     * SnackbarAction contents.
     */
    children: PropTypes.node
};
